import groq from 'groq';

import {
  ASSET,
  BAR_CHART,
  RICH_TEXT,
  STUDY_MODAL,
  VIDEO_CARD,
} from '../common';

export const BENEFITS_V2 = groq`
  kickerLabel,
  "benefits": benefitModals[]{
    _key,
    title,
    description[] {
      ${RICH_TEXT}
    },
    chart,
    "chartImage": chartImage.lightMode { ${ASSET} },
    barChart {
      ${BAR_CHART}
    },
    videoCard {
      ${VIDEO_CARD}
    },
    disclaimer,
    "modal": modal->{
      ${STUDY_MODAL}
    }
  }
`;

export const BENEFITS_V2_BLOCK = groq`
  _type == 'benefitsV2' => @ -> {
    ${BENEFITS_V2}
  }
`;
